import React, {useRef, useState} from "react";
import {NavLink} from "react-router-dom";
import PoolGroup from './PoolGroup';
// import AddTalentNavbar from "./AddTalentNavbar";
import LoadingBanner from "../../../components/LoadingBanner";

const TalentPoolNavbar = ({isLoading, groupedPools, onClick}) => {
    const inputRef = useRef(null);
    const [isAddingPoolKey, setIsAddingPoolKey] = useState(''); // one of PERSONAL | COMPANY

    if (isLoading) {
        return (
            <div className="flex flex-col gap-10 py-7 px-5 bg-white w-[306px] talent-pool-navbar">
                <LoadingBanner/>
            </div>
        )
    }


    return (
        <div className="flex flex-col gap-10 py-7 px-5 bg-white w-[306px] talent-pool-navbar">

            <div>
                <div className="flex justify-between">
                    <p className="text-lg text-wrippleBlueGray">General Talent Pools</p>
                </div>
                <ul className="pt-4 flex flex-col gap-2 text-wrippleBlueGray">
                    {groupedPools.general?.map(pool => {
                        let icon;
                        if (!pool.isVisible()) {
                            return null;
                        }
                        let poolName = pool.name;
                        if (pool.name === "Favorites") icon = 'fa-heart'
                        if (pool.name === "Past Hires") icon = 'fa-folder-open'
                        if (pool.name === "Bring Your Own Talent") {
                            poolName = <span className="whitespace-nowrap">BYOT <span className="text-xxs font-semibold italic">{pool.name}</span></span>
                            icon = 'fa-envelope'
                        }
                        return (
                            <li key={pool.id} className="flex items-center gap-2">
                                <NavLink
                                    to={`/client/talent-pool/${pool.isWrippleRecommendedPool?.() ? pool.id : TB.slugify(pool.name)}`}
                                    className={({isActive}) => `text-sm flex items-center gap-2 ${isActive ? "!text-secondary" : ""}`}
                                    onClick={() => {
                                        if (onClick) onClick();
                                        if (isAddingPoolKey) setIsAddingPoolKey('');
                                    }}
                                >
                                    {({isActive}) => (
                                        <>
                                            {pool.isWrippleRecommendedPool?.() ? (
                                                <img src={TB.logoImagePath()} alt="" className="w-4 h-4"/>
                                            ) : (
                                                <i className={`text-base ${icon} ${isActive ? 'fas' : 'far'}`}/>
                                            )}
                                            <span className="text-left">
                                                {poolName}
                                                <span
                                                    className={isActive ? 'text-secondary' : 'text-gray-400'}> ({pool.membersCount || pool.talent_users_count})</span>
                                            </span>
                                        </>
                                    )}
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <PoolGroup
                type="Company"
                groups={groupedPools.company}
                isAdding={isAddingPoolKey}
                onClick={() => {
                    if (onClick) onClick();

                    if (isAddingPoolKey) setIsAddingPoolKey('');
                }}
                // onAdd={() => {
                //     handleAddNewBtn('COMPANY');
                //     setPoolData(DEFAULT_POOL_DATA);
                //     navigate('/client/talent-pool');
                // }}
            />

            <PoolGroup
                type="Personal"
                groups={groupedPools.personal}
                isAdding={isAddingPoolKey}
                onClick={() => {
                    if (onClick) onClick();

                    if (isAddingPoolKey) setIsAddingPoolKey('');
                }}
                // onAdd={() => {
                //     handleAddNewBtn('PERSONAL');
                //     setPoolData(DEFAULT_POOL_DATA);
                //     navigate('/client/talent-pool');
                // }}
            />

        </div>
    )
}

export default TalentPoolNavbar;